import { useState, useRef, useEffect } from "react";
import EmojiPicker from "emoji-picker-react";
import { Smiley } from "@phosphor-icons/react";

/**
 * EmojiButton — small trigger that pops an emoji picker.
 * Pass `onSelect(emoji)` to receive the chosen emoji character.
 */
export default function EmojiButton({ onSelect, size = 18, className = "", testId = "emoji-btn" }) {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    const onClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    if (open) document.addEventListener("mousedown", onClickOutside);
    return () => document.removeEventListener("mousedown", onClickOutside);
  }, [open]);

  return (
    <div ref={wrapperRef} className={`relative ${className}`}>
      <button
        type="button"
        onClick={() => setOpen(v => !v)}
        className="p-1.5 text-slate-500 hover:text-slate-900 transition-colors"
        title="Add emoji"
        data-testid={testId}
      >
        <Smiley size={size} />
      </button>
      {open && (
        <div className="absolute bottom-full right-0 mb-2 z-50 shadow-xl">
          <EmojiPicker
            onEmojiClick={(e) => { onSelect(e.emoji); setOpen(false); }}
            width={300}
            height={350}
          />
        </div>
      )}
    </div>
  );
}
